import ReactGA from 'react-ga';

export const init = () => {
	console.log('GA init');
	ReactGA.initialize('UA-115463142-1')
}


export const logPageView = () => {
	console.log(`Logging pageview from ${window.location.pathname}}`);
	ReactGA.set({page: window.location.pathname})
	ReactGA.pageview(window.location.pathname)
}




// WEBPACK FOOTER //
// ./src/utils/analytics.js